var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-preview-modal t-banner-preview-modal"},[_c('div',{staticStyle:{"overflow-x":"auto"}},[_c('banner-preview',_vm._b({attrs:{"image-name":_vm.banner.imageName,"title":_vm.bannerContent.title,"text":_vm.bannerContent.text}},'banner-preview',{
        ...(_vm.bannerContent.primaryButton != null
          ? {
            primaryButtonText: _vm.bannerContent.primaryButton.text,
            primaryButtonLink: _vm.bannerContent.primaryButton.link,
            primaryButtonLinkInternal: _vm.bannerContent.primaryButton.isInternalLink
          }
          : undefined
        ),
        ...(_vm.bannerContent.secondaryButton != null
          ? {
            secondaryButtonText: _vm.bannerContent.secondaryButton.text,
            secondaryButtonLink: _vm.bannerContent.secondaryButton.link,
            secondaryButtonLinkInternal: _vm.bannerContent.secondaryButton.isInternalLink
          }
          : undefined
        )
      },false))],1),_vm._v(" "),_c('div',{staticClass:"banner-preview-modal__actions"},[_c('v-btn',{attrs:{"color":"primary","to":_vm.createBannerEditRoute(_vm.banner.id)}},[_vm._v("edit banner")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"white","outline":""},on:{"click":_vm.onCloseButtonClick}},[_vm._v("close preview")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }